module.exports = __webpack_public_path__ + "static/icon-search-065e8f255aa64897a590aa371bf4036e.png";